import { MeetingConditionStatus } from '../../../../graphql/Offer/types';

export enum EXTENDED_MEET_CONDITION_STATUS {
  PASSED_DEADLINE = 'PASSED_DEADLINE', // frontend fake status
}

export const FULL_MEET_CONDITION_STATUS = {
  ...EXTENDED_MEET_CONDITION_STATUS,
  ...MeetingConditionStatus,
};
